export default __webpack_public_path__ + "static/media/edit-icon.4fa02ba3.svg";